import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useI18n } from "@/i18n/I18nProvider";

const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export default function ContactForm() {
  const { t } = useI18n();
  const navigate = useNavigate();
  const [values, setValues] = useState({ name: "", email: "", message: "" });
  const [errors, setErrors] = useState({});
  const [submitting, setSubmitting] = useState(false);

  const setField = (name) => (e) => {
    setValues((v) => ({ ...v, [name]: e.target.value }));
    setErrors((prev) => ({ ...prev, [name]: undefined }));
  };

  const validate = () => {
    const next = {};
    if (!values.name.trim()) next.name = t("contact.errName");
    if (!EMAIL_RE.test(values.email.trim())) next.email = t("contact.errEmail");
    if (!values.message.trim() || values.message.trim().length < 4) next.message = t("contact.errMessage");
    setErrors(next);
    return Object.keys(next).length === 0;
  };

  const onSubmit = (e) => {
    e.preventDefault();
    if (!validate()) return;
    setSubmitting(true);
    // Frontend-only: no backend call. Redirect to thank-you page.
    setTimeout(() => {
      navigate("/thank_you");
    }, 250);
  };

  return (
    <form className="zx-form" onSubmit={onSubmit} noValidate>
      <div className="zx-form__field">
        <label htmlFor="zx-name">{t("contact.nameLabel")}</label>
        <input
          id="zx-name"
          type="text"
          autoComplete="name"
          value={values.name}
          onChange={setField("name")}
          placeholder={t("contact.namePlaceholder")}
          aria-invalid={!!errors.name}
        />
        {errors.name && <span className="zx-form__err">{errors.name}</span>}
      </div>
      <div className="zx-form__field">
        <label htmlFor="zx-email">{t("contact.emailLabel")}</label>
        <input
          id="zx-email"
          type="email"
          autoComplete="email"
          value={values.email}
          onChange={setField("email")}
          placeholder={t("contact.emailPlaceholder")}
          aria-invalid={!!errors.email}
        />
        {errors.email && <span className="zx-form__err">{errors.email}</span>}
      </div>
      <div className="zx-form__field">
        <label htmlFor="zx-message">{t("contact.messageLabel")}</label>
        <textarea
          id="zx-message"
          rows={5}
          value={values.message}
          onChange={setField("message")}
          placeholder={t("contact.messagePlaceholder")}
          aria-invalid={!!errors.message}
        />
        {errors.message && <span className="zx-form__err">{errors.message}</span>}
      </div>
      <button type="submit" className="zx-btn zx-btn--primary zx-btn--lg" disabled={submitting}>
        {t("contact.submit")}
      </button>
      <p className="zx-form__note">{t("contact.privacyNote")}</p>
    </form>
  );
}
